// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"2ea2d44c","183":"c895d8be","456":"ba86380b","488":"4d1bfd66","502":"6a2cc6dd","545":"25bb3c04","581":"df176c36","772":"2e31accf","842":"613b3ed3","858":"6cdef711","886":"674b952c"}[chunkId] + ".chunk.js";
};